import { useNavigate } from "react-router-dom";
import { Reveal } from "./Reveal";
import { Apple, Play, Globe } from "lucide-react";

export const FinalCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-coral text-bone py-24 md:py-36" data-testid="final-cta">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 text-center">
        <Reveal>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight">
            Ready to sell like it&apos;s 2030?
          </h2>
          <p className="mt-6 text-base md:text-lg text-bone/85">
            Start free. No credit card. Cancel anytime.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <button
            onClick={() => navigate("/download")}
            data-testid="final-cta-button"
            className="mt-10 inline-flex items-center gap-2 bg-ink text-bone px-9 py-4 text-sm font-medium hover:bg-bone hover:text-ink transition-colors duration-300"
          >
            Start free — no credit card →
          </button>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-wrap justify-center gap-3">
            {[
              { icon: Apple, label: "Download on the App Store" },
              { icon: Play, label: "Get it on Google Play" },
              { icon: Globe, label: "Use it in your browser" },
            ].map((b) => (
              <button
                key={b.label}
                onClick={() => navigate("/download")}
                className="inline-flex items-center gap-2 border border-bone/40 px-4 py-2.5 text-xs hover:bg-bone hover:text-ink transition-colors duration-300"
                data-testid={`store-badge-${b.label.split(" ")[0].toLowerCase()}`}
              >
                <b.icon className="w-4 h-4" />
                {b.label}
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
